/*
Чтобы использовать табы как ссылки и запретить им инититься как табы, добавить к элементу .ui-tabs класс .ui-tabs_nojs,
т.е. так <ul class="ui-tabs ui-tabs_nojs">
 */
(function () {
    $(function () {
        const linkActiveClassname = 'ui-tabs__link_active'
        const tabActiveClassname = 'ui-tabs-content__item_active'
        const tabVisibleClassname = 'ui-tabs-content__item_visible'
        const tabsContentActiveClassname = 'ui-tabs-content_active'
        
        $('.ui-tabs:not(.ui-tabs_nojs)').each((index, element) => {
            const $root = $(element)
            const defaultActiveId = $root.data('activeId')
            const contentId = $root.data('contentTarget')
            const $links = $root.find('.ui-tabs__link')
            const $tabsContent = $(`.ui-tabs-content[data-content-id="${contentId}"]`)

            $links.each(function () {
                const $link = $(this)
                $link.on('click', event => {
                    event.preventDefault()
                    if (!$link.is(linkActiveClassname))
                        activateLink($link)
                })
            })

            activateDefaultLink()
            
            function activateDefaultLink() {
                let $linkToActivate
                if (defaultActiveId && $('[data-item-target="' + defaultActiveId + '"]').length > 0) {
                    $linkToActivate = $links.filter('[data-item-target="' + defaultActiveId + '"]')
                } else {
                    $linkToActivate = $links.first()
                }
                activateLink($linkToActivate)
            }
            
            function activateLink($link) {
                $links.removeClass(linkActiveClassname)
                $link.addClass(linkActiveClassname)
                openTab($link.data('itemTarget'))
            }

            function closeTabs() {
                $tabsContent.find('.ui-tabs-content__item').removeClass(tabActiveClassname).removeClass(tabVisibleClassname)
            }

            function openTab(targetId) {
                closeTabs()
                const $targetTab = $tabsContent.find(`[data-item-id="${targetId}"]`)
                if ($targetTab.length > 0) {
                    $targetTab.addClass(tabActiveClassname).trigger('active').addClass(tabVisibleClassname)
                    $targetTab.one ('webkitTransitionEnd oTransitionEnd MSTransitionEnd transitionEnd', function () {
                        const event = new Event('visible');
                        $targetTab[0].dispatchEvent(event)
                    });
                    $tabsContent.addClass(tabsContentActiveClassname)
                }
            }
        })
    })
}());
